<template>
  <section>
    <div class="l-width px-5">
      <swiper
        :slidesPerView="1"
        :spaceBetween="10"
        :freeMode="true"
        :loop="true"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
        }"
        :breakpoints="{
          '300': { slidesPerView: 1 },
          '640': {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          '768': {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }"
        :navigation="true"
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide>
          <div class="rounded-t-md items-center shadow bg-white">
            <div>
              <img src="/images/pic1.png" alt="" />
            </div>
            <div class="px-5 space-y-2 border rounded-b-md py-5">
              <h3
                class="font-bold text-lg md:text-xl lg:text-2xl capitalize text-primary"
              >
                SAE 40 <br />
                PREMIUM API SL/CH4
              </h3>
              <div class="flex justify-between text-sm md:text-base lg:text-lg">
                <p class="text-text w-full leading-6">
                  Product Name:
                  <span class="text-[#777] font-bold"
                    >SAE 40 API PREMIUM ENGINE OIL
                  </span>
                </p>
                <div class="justify-self-end">
                  <router-link to="/products/automobile">
                    <img
                      src="/icons/arrow.svg"
                      class="border border-black rounded-full w-[45px] h-[40px] p-2 cursor-pointer"
                      alt=""
                  /></router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="rounded-t-md items-center border-b-2 shadow bg-white">
            <img src="/images/pic2.png" alt="" />
            <div class="px-5 space-y-2 border rounded-b-md py-5">
              <h3
                class="font-bold text-lg md:text-xl lg:text-2xl capitalize text-primary"
              >
                5W30 <br />
                FULLY SYNTHETIC
              </h3>
              <div class="flex justify-between text-sm md:text-base lg:text-lg">
                <p class="text-text w-full leading-6">
                  Product Name:
                  <span class="text-[#777] font-bold">
                    5W30 FULLY SYNTHETIC ENGINE OIL
                  </span>
                </p>
                <div class="justify-self-end">
                  <router-link to="/products/automobile">
                    <img
                      src="/icons/arrow.svg"
                      class="border border-black rounded-full w-[45px] h-[40px] p-2 cursor-pointer"
                      alt=""
                  /></router-link>
                </div>
              </div>
            </div></div
        ></swiper-slide>
        <swiper-slide>
          <div class="rounded-t-md items-center border-b-2 shadow bg-white">
            <img src="/images/pic3.png" alt="" />
            <div class="px-5 space-y-2 border rounded-b-md py-5">
              <h3
                class="font-bold text-lg md:text-xl lg:text-2xl capitalize text-primary"
              >
                SAE 20W50 <br />
                PREMIUM API
              </h3>
              <div class="flex justify-between text-sm md:text-base lg:text-lg">
                <p class="text-text w-full leading-6">
                  Product Name:
                  <span class="text-[#777] font-bold"
                    >4T SAE 20W50 PREMIUM API SL JASO ENGINE OIL
                  </span>
                </p>
                <div class="justify-self-end">
                  <router-link to="/products/automobile">
                    <img
                      src="/icons/arrow.svg"
                      class="border border-black rounded-full w-[45px] h-[40px] p-2 cursor-pointer"
                      alt=""
                  /></router-link>
                </div>
              </div>
            </div></div
        ></swiper-slide>
        <swiper-slide>
          <div class="rounded-t-md items-center border-b-2 shadow bg-white">
            <img src="/images/pic4.png" alt="" />
            <div class="px-5 space-y-2 border rounded-b-md py-5">
              <h3
                class="font-bold text-lg md:text-xl lg:text-2xl capitalize text-primary"
              >
                0W/20 <br />
                FULLY SYNTHETIC
              </h3>
              <div class="flex justify-between text-sm md:text-base lg:text-lg">
                <p class="text-text w-full leading-6">
                  Product Name:
                  <span class="text-[#777] font-bold"
                    >0W/20 FULLY SYNTHETIC GASOLIN & ENGINE OIL
                  </span>
                </p>
                <div class="justify-self-end">
                  <router-link to="/products/automobile">
                    <img
                      src="/icons/arrow.svg"
                      class="border border-black rounded-full w-[45px] h-[40px] p-2 cursor-pointer"
                      alt=""
                  /></router-link>
                </div>
              </div>
            </div></div
        ></swiper-slide>
        <swiper-slide>
          <div class="rounded-t-md items-center border-b-2 shadow bg-white">
            <img src="/images/pic5.png" alt="" />
            <div class="px-5 space-y-2 border rounded-b-md py-5">
              <h3
                class="font-bold text-lg md:text-xl lg:text-2xl capitalize text-primary"
              >
                5W30<br />
                FULLY SYNTHETIC
              </h3>
              <div class="flex justify-between text-sm md:text-base lg:text-lg">
                <p class="text-text w-full leading-6">
                  Product Name:
                  <span class="text-[#777] font-bold"
                    >5W30 FULLY SYNTHETIC ENGINE OIL
                  </span>
                </p>
                <div class="justify-self-end">
                  <router-link to="/products/automobile">
                    <img
                      src="/icons/arrow.svg"
                      class="border border-black rounded-full w-[45px] h-[40px] p-2 cursor-pointer"
                      alt=""
                  /></router-link>
                </div>
              </div>
            </div></div
        ></swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
// import required modules
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Navigation],
    };
  },
};
</script>
